/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_Api_QueryVariables = {
    serviceID: string;
    accountID: string;
    before7: string;
    after7: string;
    before30: string;
    after30: string;
    beforeYear: string;
    afterYear: string;
};
export type App_Api_QueryResponse = {
    readonly service: {
        readonly " $fragmentRefs": FragmentRefs<"Api_service">;
    } | null;
    readonly account: {
        readonly " $fragmentRefs": FragmentRefs<"Api_account">;
    };
};
export type App_Api_Query = {
    readonly response: App_Api_QueryResponse;
    readonly variables: App_Api_QueryVariables;
};



/*
query App_Api_Query(
  $serviceID: ID!
  $accountID: ID!
) {
  service: node(id: $serviceID) {
    __typename
    ... on Service {
      ...Api_service_3DPLFA
    }
    id
  }
  account(input: {accountID: $accountID}) {
    ...Api_account
    id
  }
}

fragment Api_account on Account {
  merchant {
    payments {
      stripeSetupStatus
    }
    id
  }
}

fragment Api_service_3DPLFA on Service {
  id
  name
  description
  imageURL
  secret
  supportedCurrencies
  supportableCurrencies
  charges {
    edges {
      node {
        id
        name
        description
        chargeIdentifier
        chargeType
        prices {
          amount
          currency
          id
        }
      }
    }
  }
  devSubscription {
    secret
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after30"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after7"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "afterYear"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before30"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before7"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "beforeYear"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "serviceID"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "serviceID"
  }
],
v9 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "accountID",
        "variableName": "accountID"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "secret",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "App_Api_Query",
    "selections": [
      {
        "alias": "service",
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "after30",
                    "variableName": "after30"
                  },
                  {
                    "kind": "Variable",
                    "name": "after7",
                    "variableName": "after7"
                  },
                  {
                    "kind": "Variable",
                    "name": "afterYear",
                    "variableName": "afterYear"
                  },
                  {
                    "kind": "Variable",
                    "name": "before30",
                    "variableName": "before30"
                  },
                  {
                    "kind": "Variable",
                    "name": "before7",
                    "variableName": "before7"
                  },
                  {
                    "kind": "Variable",
                    "name": "beforeYear",
                    "variableName": "beforeYear"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "Api_service"
              }
            ],
            "type": "Service",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Api_account"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "App_Api_Query",
    "selections": [
      {
        "alias": "service",
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageURL",
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportedCurrencies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportableCurrencies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChargeConnection",
                "kind": "LinkedField",
                "name": "charges",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChargeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Charge",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "chargeIdentifier",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "chargeType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Price",
                            "kind": "LinkedField",
                            "name": "prices",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "amount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "currency",
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "devSubscription",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Service",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Merchant",
            "kind": "LinkedField",
            "name": "merchant",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Payments",
                "kind": "LinkedField",
                "name": "payments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stripeSetupStatus",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b48b9f639b51afd34c372ffa5a5b8001",
    "id": null,
    "metadata": {},
    "name": "App_Api_Query",
    "operationKind": "query",
    "text": "query App_Api_Query(\n  $serviceID: ID!\n  $accountID: ID!\n) {\n  service: node(id: $serviceID) {\n    __typename\n    ... on Service {\n      ...Api_service_3DPLFA\n    }\n    id\n  }\n  account(input: {accountID: $accountID}) {\n    ...Api_account\n    id\n  }\n}\n\nfragment Api_account on Account {\n  merchant {\n    payments {\n      stripeSetupStatus\n    }\n    id\n  }\n}\n\nfragment Api_service_3DPLFA on Service {\n  id\n  name\n  description\n  imageURL\n  secret\n  supportedCurrencies\n  supportableCurrencies\n  charges {\n    edges {\n      node {\n        id\n        name\n        description\n        chargeIdentifier\n        chargeType\n        prices {\n          amount\n          currency\n          id\n        }\n      }\n    }\n  }\n  devSubscription {\n    secret\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '2d6a90d7859342f93be595cabe4d5c9a';
export default node;
